import { render, staticRenderFns } from "./CharacterManager.vue?vue&type=template&id=698f5384&scoped=true"
import script from "./CharacterManager.vue?vue&type=script&lang=js"
export * from "./CharacterManager.vue?vue&type=script&lang=js"
import style0 from "./CharacterManager.vue?vue&type=style&index=0&id=698f5384&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f5384",
  null
  
)

export default component.exports